



















































































































































































































































// #region Imports
import { Component, Mixins, Watch } from 'vue-property-decorator'
import AlterationI18nMixin from './mixins/alteration-i18n-mixin'
import DatePicker from "vue2-datepicker";
import moment from 'moment'
import { cloneDeep } from 'lodash';
// #endregion

// #region Types
type LoadStatus = 'IN_PROGRESS' | 'COMPLETE' | 'ERROR' | 'DELETED'

interface JournalEntry {
    id: number
    createdAt: string
    level: string
    region: string
    abp: string | null
    gu: string | null
    num: number | null
    request_type: string | null // TODO: convert to camelCase
    certificateDate: string | null
    certificateStatus: string | null
    name: string
    username: string
    status: LoadStatus
    reportKey: string
    filename: string
}

interface JournalResponse {
    id: number
    creation_timestamp: string
    source_tab: string
    region: string
    abp: string | null
    gu: string | null
    number: number | null
    request_type: string | null
    certificate_date: string
    certificate_status: string
    name: string
    user_id: string
    progress: number
    parameters: any // TODO: FilterSettings,
    report_key: string
    filename: string
}

interface FilterForm {
    fromDate: Date | null
    toDate: Date | null
    isByCreationDate: boolean
    level: Option<string>
    region: Option<string>
    abp: Option<string>
    gu261: Option<string>
    gu: Option<string>
    requestType: Option<string>
    status: Option<number | null>
    user: Option<string>
}

interface FilterOptions {
    levels: Option<string>[]
    regions: Option<string>[]
    abps: Option<string>[]
    gus: Option<string>[]
    gus261: Option<string>[]
    requestTypes: Option<string>[]
    statuses: Option<number | null>[]
    users: Option<string>[]
}

interface Option<T> {
    value: T
    label: string
    labelKz?: string
    labelEn?: string
}

type UserRole = 'TECH_SUPPORT_OR_CONSULTANT'
    | 'OBLAST_UO'
    | 'RAIYON_UO'
    | 'MCU_UO'
    | 'ABP'
    | 'OO'
    | 'GU'
// #endregion

const tempTableFields: { key: (keyof JournalEntry | 'action'), label: string }[] = [
    // { key: 'id', label: 'ID' },
    { key: 'createdAt', label: 'Дата формирования' },
    { key: 'level', label: 'Уровень' },
    { key: 'region', label: 'Регион' },
    { key: 'abp', label: 'АБП' },
    { key: 'gu', label: 'ГУ' },
    { key: 'num', label: '№' },
    { key: 'request_type', label: 'Тип' },
    { key: 'certificateDate', label: 'Дата справки' },
    { key: 'certificateStatus', label: 'Статус справки' },
    { key: 'name', label: 'Наименование' },
    { key: 'username', label: 'Пользователь' },
    { key: 'status', label: 'Состояние' },
    { key: 'action', label: '' },
]

const allOption = { value: '', label: 'Все', labelKz: 'Барлығы' }
const nullOption = { value: null, label: 'Все', labelKz: 'Барлығы' }
const defaultFromDate = new Date(moment().subtract(30, 'days').format('YYYY-MM-DD'))
const defaultToDate =  new Date(moment().format('YYYY-MM-DD'))
const defaultIsByCreationDate = true

const emptyForm: FilterForm = {
    fromDate: cloneDeep(defaultFromDate),
    toDate: cloneDeep(defaultToDate),
    isByCreationDate: defaultIsByCreationDate,
    level: cloneDeep(allOption),
    region: cloneDeep(allOption),
    abp: cloneDeep(allOption),
    gu261: cloneDeep(allOption),
    gu: cloneDeep(allOption),
    requestType: cloneDeep(allOption),
    status: cloneDeep(nullOption),
    user: cloneDeep(allOption),
}

const emptyOptions: FilterOptions = {
    levels: [],
    regions: [],
    abps: [],
    gus261: [],
    gus: [],
    requestTypes: [],
    statuses: [],
    users: [],
}

interface KeycloakUser {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    emailVerified: boolean;
    createdTimestamp: number;
    enabled: boolean;
    access: {
        manageGroupMembership: boolean;
        view: boolean;
        mapRoles: boolean;
        impersonate: boolean;
        manage: boolean;
    }
    createdTime: string;
}

@Component({
    components: {
        'date-picker': DatePicker,
    }
})
export default class Journal extends Mixins(AlterationI18nMixin) {

    public filterForm: FilterForm = cloneDeep(emptyForm) // for initial values look for setFilterForm
    public activeFilters: FilterForm = cloneDeep(emptyForm) // for initial values look for setFilterForm

    public filterOptions: FilterOptions = cloneDeep(emptyOptions) // for initial values look for setFilterOptions

    public userRole: UserRole | null = null
    private usersMap: Map<string, KeycloakUser> = new Map()

    public oblastCode: string = ''

    public areButtonsDisabled = false

    @Watch('filterForm.region', { deep: true })
    async onRegionChange() {
        const abpOptions = await this.fetchAbpOptions(
            this.filterForm.region.value,
            this.userId,
            this.filterForm.fromDate,
            this.filterForm.toDate,
            this.filterForm.isByCreationDate
        )
        this.filterOptions.abps = abpOptions
        // Reset selected ABP if it's not in the new options
        if (!abpOptions.find(option => option.value === this.filterForm.abp.value)) {
            this.filterForm.abp = cloneDeep(abpOptions[0])
        }

        const guOptions = await this.fetchGuOptions(
            this.userId,
            this.filterForm.abp.value,
            this.filterForm.region.value,
        )
        this.filterOptions.gus = guOptions
        // Reset selected GU if it's not in the new options
        if (!guOptions.find(option => option.value === this.filterForm.abp.value)) {
            this.filterForm.gu = cloneDeep(guOptions[0])
        }
    }

    @Watch('filterForm.abp', { deep: true })
    async onAbpChange() {
        if (this.isGu261visible) {
            return
        }

        const guOptions = await this.fetchGuOptions(
            this.userId,
            this.filterForm.abp.value,
            this.filterForm.region.value,
        )
        this.filterOptions.gus = guOptions
        // Reset selected GU if it's not in the new options
        if (!guOptions.find(option => option.value === this.filterForm.abp.value)) {
            this.filterForm.gu = cloneDeep(guOptions[0])
        }
    }

    public entries: JournalEntry[] = []
    public valuesMap: Record<string, any[]> = {
        regions: []
    }

    public progress = 0

    public readonly tableFields = tempTableFields

    private intervalId: number | null = null
    private timeouts: number[] = []

    public currentPage = 1
    public totalCount = 0

    // public updateTabRef(tabRef: string) {
    //     this.$emit('update-tab-ref', tabRef);
    // }

    // public handleSetReportParams(params: any) {
    //     this.$emit("set-report-params", params)
    // }

    get userId(): string {
        return this.$store.state.user.sub;
    }

    get isGuActive(): boolean {
        return this.filterForm.level.value !== 'requestABP/referenceABP'
            && this.filterForm.level.value !== 'refined_plan'
            && this.filterForm.level.value !== 'reference_income'
            && this.filterForm.level.value !== 'reference_expenses'
    }

    get isAbpActive(): boolean {
        return this.filterForm.level.value !== 'refined_plan'
            && this.filterForm.level.value !== 'reference_income'
            && this.filterForm.level.value !== 'reference_expenses'
    }

    get isRequestTypeActive(): boolean {
        return this.filterForm.level.value !== 'scorr_plan'
            && this.filterForm.level.value !== 'refined_plan'
    }

    get isGu261visible(): boolean {
        const eligibleUserRoles: UserRole[] = ['OO', 'TECH_SUPPORT_OR_CONSULTANT', 'OBLAST_UO']
        
        const isVisible = this.filterForm.level.value === 'requestGA'
            && this.filterForm.abp.value === '261' 
            && eligibleUserRoles.includes(this.userRole as UserRole)

        if (isVisible) { // Side effect to load gu options when gu261 is visible
            this.fetchGu261ChildGuOptions(this.filterForm.gu261.value, this.oblastCode).then(options => {
                this.filterOptions.gus = options
                this.filterForm.gu = cloneDeep(options[0])
            })
        } else {
            this.fetchGuOptions(this.userId, this.filterForm.abp.value, this.filterForm.region.value).then(options => {
                this.filterOptions.gus = options
                this.filterForm.gu = cloneDeep(options[0])
            })
        }

        return isVisible
    }

    private async created() {
        await this.loadUsers()
        await this.setUserRole()
        await this.setOblastCode()
        await this.setFilterOptions()
        await this.setFilterForm()
        await this.applyFiltersAndLoadJournal()
        this.startProgressivePollingInProcessEntries()
    }

    private beforeDestroy() {
        this.stopPollingInProcessEntries()
    }

    private async loadUsers() {
        try {
            const response = await fetch('/api-py/get-realm-users-include-disabled')
            const data = await response.json()
            const usersById = new Map<string, KeycloakUser>(
                data.map((u: any) => [u.id, u])
            )
            this.usersMap = usersById
        } catch (error) {
            console.error(error)
        }
    }

    private async setUserRole() {
        const response = await fetch(`/api-py/alteration/journal/user-role/${this.userId}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось определить роль пользователя')
            throw new Error('Ошибка загрузки роли пользователя')
        }
        const responseBody: { role: UserRole } = await response.json()
        this.userRole = responseBody.role
    }

    private async setOblastCode() {
        const katoCode = this.$store.state._instanceCode || '55' // 55 for test
        const response = await fetch(`/api-py/monitoring/reports-constructor/tax-region/${katoCode}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось определить код области')
            throw new Error('Ошибка загрузки кода области')
        }
        const oblastCode = await response.json()
        this.oblastCode = oblastCode
    }

    private async setFilterOptions() {
        const regionOptions = await this.fetchRegionOptions(this.userId, this.oblastCode)

        const abpOptions: Option<string>[] = await this.fetchAbpOptions(
            regionOptions[0].value,
            this.userId,
            cloneDeep(defaultFromDate),
            cloneDeep(defaultToDate),
            defaultIsByCreationDate,
        )

        const guOptions = await this.fetchGuOptions(this.userId, abpOptions[0].value, regionOptions[0].value)

        const gu261Options = await this.fetchGu261Options(this.userId, this.oblastCode)

        const tempFilterOptions: FilterOptions = {
            levels: await this.fetchLevelOptions(this.userId),
            regions: regionOptions,
            abps: abpOptions,
            gus: guOptions,
            gus261: gu261Options,
            requestTypes: await this.fetchRequestTypeOptions(),
            statuses: await this.fetchStatusOptions(),
            users: await this.fetchUserOptions(this.userId),
        }
        
        this.filterOptions = tempFilterOptions
    }

    private async setFilterForm() {
        let userOption = this.filterOptions.users[0]
        const currentUserOption = this.filterOptions.users.find(it => it.value === this.userId)
        if (currentUserOption) {
            userOption = currentUserOption
        }

        const tempFilterForm: FilterForm = {
            fromDate: cloneDeep(defaultFromDate), 
            toDate: cloneDeep(defaultToDate),
            isByCreationDate: true,
            level: this.filterOptions.levels[0],
            region: this.filterOptions.regions[0],
            abp: this.filterOptions.abps[0],
            gu261: this.filterOptions.gus261[0],
            gu: this.filterOptions.gus[0],
            requestType: this.filterOptions.requestTypes[0],
            status: this.filterOptions.statuses[0],
            user: userOption,
        }
        
        this.filterForm = tempFilterForm
    }

    private async fetchLevelOptions(userId: string): Promise<Option<string>[]> {        
        const response = await fetch(`/api-py/alteration/journal/options/levels/${userId}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции уровней')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string }[] = await response.json()

        const options: Option<string>[] = [cloneDeep(allOption)]
        responseBody.forEach(item => {
            options.push({ value: item.value, label: item.label })
        })

        return options
    }

    private async fetchRegionOptions(userId: string, oblastCode: string): Promise<Option<string>[]> {        
        if (!userId && !oblastCode) {
            return [cloneDeep(allOption)]
        }

        const searchParams = new URLSearchParams()
        searchParams.append('user_id', userId)
        searchParams.append('oblast_code', oblastCode)

        const response = await fetch(`/api-py/alteration/journal/options/regions?${searchParams.toString()}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции регионов')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string, label_kz: string }[] = await response.json()

        const options: Option<string>[] = []
        responseBody.forEach(item => {
            const label = `${item.value} - ${item.label}`
            const labelKz = `${item.value} - ${item.label_kz || item.label}`
            options.push({ value: item.value, label: label, labelKz: labelKz })
        })

        if (options.length !== 1) {
            options.unshift(cloneDeep(allOption))
        }

        return options
    }

    private async fetchAbpOptions(
        region: string,
        userId: string,
        fromDate: Date | null,
        toDate: Date | null,
        isByCreationDate: boolean
    ): Promise<Option<string>[]> {
        if (!region || !userId) {
            return [cloneDeep(allOption)]
        }

        const searchParams = new URLSearchParams()
        searchParams.append('region', region)
        searchParams.append('user_id', userId)
        if (fromDate) {
            searchParams.append('fromDate', moment(fromDate).format('YYYY-MM-DD'))
        }
        if (toDate) {
            searchParams.append('fromDate', moment(toDate).format('YYYY-MM-DD'))
        }
        searchParams.append('is_by_creation_date', isByCreationDate ? 'true' : 'false')

        const response = await fetch(`/api-py/alteration/journal/options/abp?${searchParams.toString()}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции АБП')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string, label_kz: string }[] = await response.json()

        const options: Option<string>[] = [cloneDeep(allOption)]
        responseBody.forEach(item => {
            const label = `${item.value} - ${item.label}`
            const labelKz = `${item.value} - ${item.label_kz || item.label}`
            options.push({ value: item.value, label: label, labelKz: labelKz })
        })

        return options
    }

    private async fetchGuOptions(
        userId: string,
        abp: string,
        region: string,
    ): Promise<Option<string>[]> {
        if (!userId || !abp || !region) {
            return [cloneDeep(allOption)]
        }

        const searchParams = new URLSearchParams()
        searchParams.append('user_id', userId)
        searchParams.append('abp', abp)
        searchParams.append('region', region)

        const response = await fetch(`/api-py/alteration/journal/options/gu?${searchParams}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции ГУ')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string, label_kz: string | null, label_en: string | null }[] = await response.json()

        const options: Option<string>[] = [cloneDeep(allOption)]
        responseBody.forEach(item => {
            const label = `${item.value} - ${item.label}`
            const labelKz = `${item.value} - ${item.label_kz || item.label}`
            const labelEn = `${item.value} - ${item.label_en || item.label}`
            options.push({ value: item.value, label: label, labelKz: labelKz, labelEn: labelEn })
        })

        return options
    }

    private async fetchGu261Options(userId: string, oblastCode: string): Promise<Option<string>[]> {
        if (!userId || !oblastCode) {
            return [cloneDeep(allOption)]
        }

        const searchParams = new URLSearchParams()
        searchParams.append('user_id', userId)
        searchParams.append('oblast_code', oblastCode)

        const response = await fetch(`/api-py/alteration/journal/options/gu261?${searchParams.toString()}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции отделов образования')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string }[] = await response.json()

        const options: Option<string>[] = []
        responseBody.forEach(item => {
            const label = `${item.value} - ${item.label}`
            options.push({ value: item.value, label: label, labelKz: label, labelEn: label })
        })

        if (options.length !== 1) {
            options.unshift(cloneDeep(allOption))
        }

        return options
    }

    private async fetchGu261ChildGuOptions(parentGu: string, oblastCode: string): Promise<Option<string>[]> {
        if (!parentGu || !oblastCode) {
            return [cloneDeep(allOption)]
        }

        const searchParams = new URLSearchParams()
        searchParams.append('parent_gu', parentGu)
        searchParams.append('oblast_code', oblastCode)

        const response = await fetch(`/api-py/alteration/journal/options/gu261-child-gu?${searchParams.toString()}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции подведомственных ГУ')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string }[] = await response.json()

        const options: Option<string>[] = []
        responseBody.forEach(item => {
            const label = `${item.value} - ${item.label}`
            options.push({ value: item.value, label: label, labelKz: label, labelEn: label })
        })

        if (options.length !== 1) {
            options.unshift(cloneDeep(allOption))
        }

        return options
    }

    private async fetchRequestTypeOptions(): Promise<Option<string>[]> {        
        const response = await fetch(`/api-py/alteration/journal/options/request-types`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции видов заявок')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string, label_kz: string | null, label_en: string | null }[] = await response.json()

        const options: Option<string>[] = [cloneDeep(allOption)]
        responseBody.forEach(it => {
            options.push({
                value: it.value,
                label: it.label,
                labelKz: it.label_kz || undefined,
                labelEn: it.label_en || undefined
            })
        })

        return options
    }

    private async fetchStatusOptions(): Promise<Option<number | null>[]> {        
        const response = await fetch(`/api-py/alteration/journal/options/statuses`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции статусов')
            return [cloneDeep(nullOption)]
        }
        
        const responseBody: { value: number, label: string, label_kz: string | null, label_en: string | null }[] = await response.json()

        const options: Option<number | null>[] = [cloneDeep(nullOption)]
        responseBody.forEach(it => {
            const labelKz: string = it.label_kz || it.label
            const labelEn: string = it.label_en || it.label
            options.push({
                value: it.value,
                label: it.label,
                labelKz: labelKz,
                labelEn: labelEn
            })
        })

        return options
    }

    private async fetchUserOptions(userId: string): Promise<Option<string>[]> {        
        const response = await fetch(`/api-py/alteration/journal/options/users/${userId}`)
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Не удалось загрузить опции пользователей')
            return [cloneDeep(allOption)]
        }
        
        const responseBody: { value: string, label: string }[] = await response.json()

        const options: Option<string>[] = [cloneDeep(allOption)]
        responseBody.forEach(it => {
            const user = this.usersMap.get(it.value)
            const fullname = user ? `${user.firstName??''} ${user.lastName??''}` : it.label

            options.push({
                value: it.value,
                label: fullname,
                labelKz: fullname,
                labelEn: fullname,
            })
        })

        const unique = [...new Map(options.map(it => [it.value, it])).values()]
        
        return unique
    }

    private async checkInProgressAndLoadJournalEntries() {
        const isInProgressPresent = Boolean(this.entries.find(it => it.status === 'IN_PROGRESS'))
        if (!isInProgressPresent) {
            return
        }

        await this.loadJournalEntries()
    }

    private async loadJournalEntries() {
        this.progress = 30
        const responseRecords = await this.fetchJournalRecords(
            this.userId,
            this.currentPage,
            this.activeFilters,
            this.filterOptions
        )
        this.progress = 90
        const records = responseRecords.records
        this.totalCount = responseRecords.totalCount
        const valuesMap = await this.fetchValuesMap(records)
        this.progress = 95

        const entries = await this.convertToJournalEntries(records)
        this.valuesMap = valuesMap
        this.entries = entries
        this.progress = 100
    }

    public async onPageChange(page: number) {
        this.currentPage = page
        await this.loadJournalEntries()
    }

    public async onApplyFilter() {
        await this.applyFiltersAndLoadJournal()
    }

    private async applyFiltersAndLoadJournal() {
        this.activeFilters = cloneDeep(this.filterForm)
        this.currentPage = 1
        await this.loadJournalEntries()
    }

    public async onResetFilter() {
        try {
            this.areButtonsDisabled = true
            await this.setFilterOptions()
            await this.setFilterForm()
        } catch (error) {
            console.error(error)
            this.makeToast('danger', 'Ошибка', 'Произошла ошибка при сбросе')
        } finally {
            this.areButtonsDisabled = false
        }
    
    }

    private async fetchJournalRecords(userId: string, page: number, filterForm: FilterForm, filterOptions: FilterOptions): Promise<{
        records: JournalResponse[]
        totalCount: number
    }> {
        const params: Record<string, string> = {
            'user_id': userId,
            'page': String(page), // page starts from 1
        }
        const searchParams = new URLSearchParams(params);
        
        // Level
        if (filterForm.level.value === '') {
            const levelValues = filterOptions.levels.map(it => it.value)
            levelValues.forEach(it => searchParams.append('levels', it))
        } else {
            searchParams.append('levels', filterForm.level.value)
        }

        // Period
        if (filterForm.fromDate) {
            const fromDateStr: string = moment(filterForm.fromDate).format('YYYY-MM-DD')
            searchParams.append('from_date', fromDateStr)
        }
        if (filterForm.toDate) {
            const toDateStr: string = moment(filterForm.toDate).format('YYYY-MM-DD')
            searchParams.append('to_date', toDateStr)
        }
        searchParams.append('is_by_creation_date', filterForm.isByCreationDate ? 'true' : 'false')

        // Region
        if (filterForm.region.value !== '') {
            searchParams.append('region', filterForm.region.value)
        }

        // ABP
        if (filterForm.abp.value !== '' && this.isAbpActive) {
            searchParams.append('abp', filterForm.abp.value)
        }

        // GU
        if (filterForm.gu.value !== '' && this.isGuActive) {
            searchParams.append('gu', filterForm.gu.value)
        }

        // Request Type
        if (filterForm.requestType.value !== '' && this.isRequestTypeActive) {
            searchParams.append('request_type', filterForm.requestType.value)
        }

        // Status
        if (filterForm.status.value != null) {
            searchParams.append('status', filterForm.status.value.toString())
        }

        // User
        if (filterForm.user.value !== '') {
            searchParams.append('author', filterForm.user.value)
        }

        const response = await fetch(`/api-py/alteration/journal?${searchParams.toString()}`)
        if (!response.ok) {
            const errorData = await response.json().catch(() => null); 
            const errorText = await response.text().catch(() => 'No text');
            console.error(`Error ${response.status}:`, errorData || errorText);
            this.makeToast('danger', 'Ошибка', 'Ошибка загрузки журнала')
            return {
                records: [],
                totalCount: 0
            }
        }
        const responseBody: { items: JournalResponse[], total_count: number } = await response.json()
        return {
            records: responseBody.items,
            totalCount: responseBody.total_count
        }
    }

    private async convertToJournalEntries(responseRecords: JournalResponse[]): Promise<JournalEntry[]> {
        try {
            const entries: JournalEntry[] = responseRecords.map(record => {
                let loadStatus: LoadStatus = 'ERROR'
                if (record.progress >= 100) {
                    loadStatus = 'COMPLETE'
                } else if (record.progress < 100 && record.progress >= 0) {
                    loadStatus = 'IN_PROGRESS'
                } else if (record.progress === -2) {
                    loadStatus = 'DELETED'
                }

                const user = this.usersMap.get(record.user_id)
                const fullname = user ? `${user.firstName??''} ${user.lastName??''}` : ''

                const formattedCreatedAt = this.formatDateTime(record.creation_timestamp)
                const formattedCertificateDate = this.formatDate(record.certificate_date)

                const filename: string = this.getFilename(record)

                const entry: JournalEntry = {
                    id: record.id,
                    createdAt: formattedCreatedAt,
                    level: record.source_tab,
                    region: record.region,
                    abp: record.abp,
                    gu: record.gu,
                    num: record.number,
                    request_type: record.request_type,
                    certificateDate: formattedCertificateDate,
                    certificateStatus: record.certificate_status,
                    name: record.name,
                    username: fullname,
                    status: loadStatus,
                    reportKey: record.report_key,
                    filename: filename
                }

                return entry
            })
            return entries
        } catch (error) {
            console.error(error)
            return []
            // TODO: toast
            // makeToast(this, 'Не удалось загрузить данные журнала', 'Ошибка', 'danger')
        } finally {
            // const isInProgressPresent = Boolean(this.entries.find(it => it.status === 'IN_PROGRESS'))
            // if (!isInProgressPresent && this.intervalId != null) {
            //     this.stopPollingInProcessEntries()
            // }
        }
    }

    private getFilename(entry: JournalResponse): string {
        if (entry.filename && entry.filename.trim() !== '') {
            return entry.filename
        }

        const extension = this.getExtension(entry) // TODO: to support older entries without filename, remove later
        const filename = `${entry.name}.${extension}`
        return filename
    }

    private async fetchValuesMap(records: JournalResponse[]): Promise<Record<string, any[]>> {
        const regionCodes: string[] = records.map(it => it.region)
        const userIds: string[] = records.map(it => it.user_id)
        const params = {
            'regions': regionCodes,
            'user_ids': userIds
        }
        const response = await fetch('/api-py/alteration/journal/values-map', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(params)
        })
        if (!response.ok) {
            this.makeToast('danger', 'Ошибка', 'Ошибка загрузики значении')
            return {}
        }
        const valuesMap: Record<string, any[]> = await response.json()
        return valuesMap
    }

    private formatDateTime(dateStr: string): string {
        const date = new Date(dateStr)

        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const year = date.getFullYear()

        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')

        return `${day}.${month}.${year} ${hours}:${minutes}`
    }

    private formatDate(dateStr: string): string {
        const date = new Date(dateStr)

        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
        const year = date.getFullYear()

        return `${day}.${month}.${year}`
    }

    public async downloadReport(entry: JournalEntry) {
        this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте')
        try {
            const response = await fetch(`/api-py/alteration/journal/file/${entry.id}`)
            if (!response.ok) {
                this.makeToast('danger', 'Ошибка', 'Не удалось скачать файл')
                const errorData = await response.json().catch(() => null); 
                const errorText = await response.text().catch(() => 'No text');
                console.error(`Error ${response.status}:`, errorData || errorText);
            }

            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', entry.filename)
            document.body.appendChild(link)
            link.click()
        } catch (error) {
            console.error(error)
            this.makeToast('danger', 'Не удалось загрузить отчет', 'Ошибка')
        }
    }

    public async deleteEntry(entryId: number) {
        try {
            const response = await fetch(`/api-py/alteration/journal/${entryId}`, {
                'method': 'DELETE'
            })
            if (!response.ok) {
                throw new Error('')
            }

            this.makeToast('success', 'Сообщение', 'Удалено')
        } catch (error) {
            console.error(error)
            this.makeToast('danger', 'Ошибка', 'Удаление не удалось')
        } finally {
            await this.loadJournalEntries()
        }
    }

    public async updateEntry(entryId: number) {
        try {
            const response = await fetch(`/api-py/alteration/journal/${entryId}`, {
                'method': 'PUT'
            })
            if (!response.ok) {
                throw new Error('')
            }

            this.makeToast('success', 'Сообщение', 'Обновление запущено')
        } catch (error) {
            console.error(error)
            this.makeToast('danger', 'Ошибка', 'Не удалось начать обновление')
        }
        await this.loadJournalEntries()
    }

    public async stopProcessing(entryId: number) {
        try {
            const response = await fetch(`/api-py/alteration/journal/stop/${entryId}`, {
                'method': 'PUT'
            })
            if (!response.ok) {
                throw new Error('')
            }

            this.makeToast('success', 'Сообщение', 'Прервано')
        } catch (error) {
            console.error(error)
            this.makeToast('danger', 'Ошибка', 'Не удалось прервать')
        } finally {
            await this.loadJournalEntries()
        }
    }

    // public async stopReportFormation(record: JournalRecord) {
    //     try {
    //         const response = await fetch(`/api-py/monitoring/reports-constructor/journal/stop/${record.id}`)
    //         if (!response.ok) {
    //             throw new Error('')
    //         }
    //         await this.loadJournalRecords()
    //     } catch (error) {
    //         makeToast(this, 'Не удалось загрузить отчет', 'Ошибка', 'danger')
    //     }
    // }

    private startProgressivePollingInProcessEntries() {
        // Immediate call
        this.checkInProgressAndLoadJournalEntries()

        // After 3 seconds
        this.timeouts.push(setTimeout(() => {
            this.checkInProgressAndLoadJournalEntries()
            // After 6 seconds
            this.timeouts.push(setTimeout(() => {
                this.checkInProgressAndLoadJournalEntries()
                // Every 15 seconds indefinitely
                this.intervalId = setInterval(this.checkInProgressAndLoadJournalEntries, 15_000)
            }, 6_000))
        }, 3_000))
    }

    private stopPollingInProcessEntries() {
        if (this.intervalId != null) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
        this.timeouts.forEach(clearTimeout)
        this.timeouts = []
    }

    // TODO: move to dateUtils
    private formatDateString(dateString: string): string {
        const date = new Date(dateString);

        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // Extract time components
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the date and time components into the desired format
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    private getExtension(entry: JournalResponse): string {
        let extension = 'xlsx'
        if (
            entry.source_tab === 'balance'
            || entry.report_key === 'BASE'
            || entry.name.includes('ИПФ (скорректированный)')
        ) {
            extension = 'xls'
        }

        return extension
    }

    getStatusStyle(status: LoadStatus): string {
        switch (status) {
            case 'COMPLETE': return 'status-completed';
            case 'IN_PROGRESS': return 'status-in-progress';
            case 'ERROR': return 'status-error';
            case 'DELETED': return 'status-deleted';
            default: return ''
        }
    }

    /** Перевод */
    // TODO: add Kazakh/English
    private tr(value: string, source: null | 'level' | 'regions' | 'agreement_statuses' | 'request_types' | 'status' = null): string {
        if (!source) {
            const key = `modules.budget_execution_alteration.${value}`
            const text: string = String(this.$t(key))
            return text || value
        }

        if (source === 'status') {
            switch (value) {
                case 'COMPLETE': return 'ОБРАБОТАНО'
                case 'DELETED': return 'ФАЙЛ УДАЛЕН'
                case 'ERROR': return 'ОШИБКА'
                case 'IN_PROGRESS': return 'В ОБРАБОТКЕ'
                default: return ''
            }
        }

        if (source === 'level') {
            const key = `modules.budget_execution_alteration.${value}`
            const text: string = String(this.$t(key))
            return text || value
        }

        if (source === 'regions') {
            const item = this.valuesMap[source].find(it => it.code === value)
            if (item) {
                return `${item.code} - ${item.name_ru}`
            }
            return value
        }

        const item = this.valuesMap[source].find(it => it.code == value)
        return item?.name_ru ?? value
    }

    makeToast(variant: 'success' | 'danger' | 'info', title: string, tostbody: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        })
    }
}
